//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.FaceChangeOverflowBehavior.js";
import "../Features/Features.FaceRecognitionBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[1,"AxisSel",0,"SelectFace",0],[1,"Diameter",0,"Expression",0],[0,"DimensionType",1,0],[1,"Distance",0,"Expression",0],[1,"FaceChangeOverflowBehavior",0,"GeometricUtilities.FaceChangeOverflowBehavior",0],[1,"FaceToRadiate",0,"Features.FaceRecognitionBuilder",0],[1,"Radius",0,"Expression",0],[1,"Reference",0,"SelectFace",0],[0,"ReverseDirection",1,0]],[],[]];
SPLM.Features.RadiateFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RadiateFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RadiateFaceBuilder.DimensionTypes = Object.freeze({
    "Offset" : "Offset", "Diameter" : "Diameter", "Radius" : "Radius"});

export default SPLM;